import { SchedulingProposalStateEnum } from "@clockwise/schema";
import { useLaunchConfetti } from "@clockwise/web-commons/src/hooks/useLaunchConfetti";
import classNames from "classnames";
import { isEmpty } from "lodash";
import React from "react";
import { useFeatureFlag } from "../../../../launch-darkly";
import { DebugBlock } from "../../web/DebugBlock";
import { useAIMessageContext } from "../hooks/AIMessageContext";
import { AssistantMessageType } from "../utils/types";
import { TextResponse } from "./TextRespsonse";
import { ViewEventsResponse } from "./ViewEventsResponse";
import { ProposalResponse } from "./proposal";
import { EventSearchBlock } from "./proposal/event-search/EventSearchBlock";
import { SchedulingLinksResponse } from "./scheduling-link/SchedulingLinksResponse";

export const AssistantMessage = ({
  message,
  debugInfo,
}: {
  message: AssistantMessageType;
  debugInfo?: string;
}) => {
  const { processingMessage, confirmingMessage } = useAIMessageContext();
  const [eventSearchEnabled] = useFeatureFlag("AIEventSearch");

  const launchConfetti = useLaunchConfetti();

  // Only show for active proposals with a populated event search, or for any view events with event search
  const showEventSearch =
    ((message.__typename === "ProposalResponse" &&
      !isEmpty(message.proposal.eventSearchBlocks) &&
      message.proposal.state === SchedulingProposalStateEnum.ACTIVE) ||
      (message.__typename === "ViewEventsResponse" && !isEmpty(message.eventSearchBlocks))) &&
    eventSearchEnabled;

  const returnMessageByType = (assistantMessage: AssistantMessageType) => {
    const messageType = assistantMessage.__typename;
    switch (messageType) {
      case "TextResponse":
        return <TextResponse message={assistantMessage} />;
      case "ProposalResponse":
        return <ProposalResponse triggerConfetti={launchConfetti} message={assistantMessage} />;
      case "ViewEventsResponse":
        return <ViewEventsResponse message={assistantMessage} />;
      case "SchedulingLinksResponse":
        return <SchedulingLinksResponse message={assistantMessage} />;
    }
  };

  const eventSearchBlocks =
    message.__typename === "ProposalResponse"
      ? message.proposal.eventSearchBlocks
      : message.__typename === "ViewEventsResponse"
      ? message.eventSearchBlocks
      : [];

  const loading =
    (processingMessage || confirmingMessage) && message.__typename === "ProposalResponse";

  const conversationId = message.conversationId;

  return (
    <div cw-id="assisstant-message" className="cw-flex-col">
      {showEventSearch && (
        <>
          {eventSearchBlocks.map((eventSearchBlock, index) => (
            <div className="cw-mb-2" key={`eventSearchBlock-${index}`}>
              <EventSearchBlock
                eventSearchBlock={eventSearchBlock}
                conversationId={conversationId}
              />
            </div>
          ))}
        </>
      )}
      <div className={classNames("cw-w-full cw-body-sm cw-text-13", { "cw-opacity-60": loading })}>
        {returnMessageByType(message)}
      </div>
      {debugInfo && <DebugBlock debugInfo={debugInfo} />}
    </div>
  );
};
